import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setIsRPMViewLoading } from "app/store/rpm/slice/rpmSlice";
import { useGetRpmCliniiViewQuery } from "app/store/rpm/api/rpmApi";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";

import Loading from "components/common/loading/Loading";
import Button from "components/common/button/Button";

const RpmView = () => {
  const dispatch = useDispatch();

  const {
    data: cliniiSignInPortalLink,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetRpmCliniiViewQuery({}, { refetchOnMountOrArgChange: true });

  useEffect(() => {
    dispatch(setTitle({ title: "RPM Patients" }));
  }, []);

  useEffect(() => {
    dispatch(setIsRPMViewLoading(isLoading || isFetching));
  }, [isFetching, isLoading]);

  return (
    <div style={{ height: "98vh" }}>
      {isLoading && <Loading height="98vh" />}

      {isError && (
        <div
          className="d-flex flex-column align-items-center text-center"
          style={{ height: "98vh", justifyContent: "center" }}
        >
          <h2>Something went wrong</h2>
          <p>Couldn’t load the RPM view. Please try again.</p>
          <Button onClick={refetch} label="Retry" className="mt-2" />
        </div>
      )}

      {cliniiSignInPortalLink && (
        <iframe
          title="Clinii Interface"
          src={cliniiSignInPortalLink}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      )}
    </div>
  );
};

export default RpmView;
